import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "text-center": !_vm.isMobile },
      attrs: { "data-qa": "user_authorization_phone_to_call" },
    },
    [
      _c("div", { staticClass: "text-body-1 text--text mb-4" }, [
        _vm._v(
          "\n    Для подтверждения позвоните нам.\n    Вам не придётся ничего говорить: система сама завершит звонок.\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.isMobile
        ? _c(
            VBtn,
            {
              staticClass: "mb-4",
              attrs: {
                block: "",
                elevation: "0",
                color: "primary",
                href: `tel:${_vm.authPhoneTel}`,
                "data-qa": "user_authorization_phone_to_call_button",
              },
            },
            [_vm._v("\n    Позвонить " + _vm._s(_vm.authPhone) + "\n  ")]
          )
        : _c(
            "div",
            {
              staticClass: "text-h4 text--text mb-2",
              attrs: { "data-qa": "user_authorization_phone_to_call_number" },
            },
            [_vm._v("\n    " + _vm._s(_vm.authPhone) + "\n  ")]
          ),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text--text text-center" }, [
        _vm._v("\n    Звонок бесплатный\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }